import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  
  async pesquisarCadastros(api, parametros) {    
    parametros.operacao = 'pesquisarCadastros';

    let retorno = {};

    await api.santriGET('/rest/cadastro', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCadastro.js